export const linkedRequisitionPath = (id: number): string =>
  `/procurement/requisition?requisitionId=${encodeURIComponent(id)}`
